/* eslint complexity: ["error", 5], max-params: ["error", 3], max-depth: ["error", 2], max-statements: ["error", 10] */

'use strict';

var VIEWS = {
    switcher: require('../modules/views/accommodation_sorting_switcher'),
    drop_down: require('../modules/views/accommodation_sorting_drop_down'),
    lightbox: require('../modules/views/accommodation_sorting_lightbox'),
};
var helper = require('../modules/helpers/accommodation_sorting');

Odigeo.defineWidget('accommodation_sorting', Odigeo.Widget.extend({
    modelClass: require('../modules/models/accommodation_sorting'),

    beforeConstructView: function() {
        this.options = Odigeo.Utils.parseOptions(this.options);
        this.viewClass = VIEWS[this.options.viewType];
    },

    setDefaultSortingOrder: function(accommodationSortingOrder) {
        this.view.setDefaultOrder(accommodationSortingOrder.accommodationSortingOrder);
    },

    resetSwitcher: function() {
        this.toggleSortingDisabled(true);
        this.model.setModelNoSync({'accommodationSortingOrder': ''});
    },

    setInitialSorting: function(accommodationSortingOrder) {
        this.model.setModelNoSync(helper.getAccommodationSortingOrder(accommodationSortingOrder));
    },

    toggleSortingDisabled: function(disable) {
        this.view.toggleSortingDisabled(disable);
    },

    activateSortBy: function() {
        this.view.activateSortBy();
    },

    deactivateSortBy: function() {
        this.view.deactivateSortBy();
    },

    updateSortingCoordinates: function(coordiates) {
        this.view.updateSortingCoordinates(coordiates);
    },

    updateSorting: function(sortingConfig) {
        this.view.updateSorting(sortingConfig);
    },

    init: Odigeo._.noop,
}));

